import DeviceFactory from './Factory';

module.exports = {
  DeviceFactory
}
